import { render } from "./BookingForm2.vue?vue&type=template&id=62f6ef0e&scoped=true"
import script from "./BookingForm2.vue?vue&type=script&lang=js"
export * from "./BookingForm2.vue?vue&type=script&lang=js"

import "./BookingForm2.vue?vue&type=style&index=0&id=62f6ef0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62f6ef0e"

export default script